import { Box, Flex, Text } from '@everlywell/ui-kit';
import React from 'react';

import { EvaIcon } from '../../../../components/PageSections/DynamicQuizModal/BiomarkerInsights/EvaIcon';
import type { EvaThinkingIndicatorProps } from '../../types/components';

export default function EvaThinkingIndicator({
  variant = 'page',
  label = 'Eva is thinking...',
}: EvaThinkingIndicatorProps): JSX.Element {
  if (variant === 'widget') {
    return (
      <Text fontSize="sm" color="tints.uiGrey">
        {label}
      </Text>
    );
  }

  return (
    <Flex
      width="100%"
      justifyContent="flex-start"
      alignItems="center"
      marginTop={24}
      gap="12px"
      sx={{
        // Prevent flicker on mount/unmount with fade transition
        animation: 'thinkingFadeIn 0.2s ease-out',
        '@keyframes thinkingFadeIn': {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
      }}
    >
      <Box
        padding="4px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        <Box
          backgroundColor="violet.lighter"
          borderRadius="full"
          padding={2}
          display="flex"
          alignItems="center"
          sx={{
            animation: `pulse 2.5s ease-in-out infinite`,
            '@keyframes pulse': {
              '0%, 100%': {
                boxShadow: '0 0 0 0 rgba(230,173,255, 0)',
              },
              '50%': {
                boxShadow: '0 0 0 4px rgba(230,173,255, 0.4)',
              },
            },
          }}
        >
          <Box
            sx={{
              animation: 'scaleUp 2.5s ease-in-out infinite',
              '@keyframes scaleUp': {
                '0%, 100%': { transform: 'scale(1)' },
                '50%': { transform: 'scale(1.2)' },
              },
            }}
          >
            <EvaIcon />
          </Box>
        </Box>
      </Box>
      <Text
        color="#949494"
        sx={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
        fontFamily="DM Sans"
        fontSize="1rem"
        fontStyle="normal"
        fontWeight="400"
        lineHeight="150%"
      >
        {label}
      </Text>
    </Flex>
  );
}
